module.exports = __webpack_public_path__ + "static/media/map.82fcb27c.svg";